import React from "react";

const DepositIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 18" fill="none">
      <path
        d="M10.1779 5.79984H14.0889C14.2762 5.798 14.4565 5.87081 14.5899 6.00221C14.7234 6.13361 14.799 6.31276 14.8 6.50003V16.2997C14.799 16.4869 14.7234 16.6661 14.5899 16.7975C14.4565 16.9289 14.2762 17.0017 14.0889 16.9999H2.71104C2.52377 17.0017 2.34348 16.9289 2.21004 16.7975C2.0766 16.6661 2.00101 16.4869 2 16.2997V6.50003C2.00101 6.31276 2.0766 6.13361 2.21004 6.00221C2.34348 5.87081 2.52377 5.798 2.71104 5.79984H6.62207"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.3999 1V9.95996"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.35205 8.04004L8.40005 9.96003L10.448 8.04004"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DepositIcon;
